import useSuspenseQueryProfile from '@/modules/auth/api/hooks/useSuspenseQueryProfile/index.'
import { Navigate, Outlet, useLocation } from 'react-router-dom'

function DashBoardRolePermissionGuardComponent() {
	const { pathname } = useLocation()

	const { data: user } = useSuspenseQueryProfile()

	if (!user) return <Navigate to="/login" />
	if (pathname.startsWith('/admin')) {
		if (user.userGroup) {
			return <Navigate to="/operator" />
		}
	} else if (pathname.startsWith('/operator')) {
		if (!user.userGroup) {
			return <Navigate to="/admin" />
		}
	}

	return <Outlet />
}

export default DashBoardRolePermissionGuardComponent
